// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1RLEO","footer":"ModalError_footer__3NntG"};